/* eslint-disable warp-drive/no-legacy-request-patterns */
// Extends From

import Route from '@ember/routing/route';

// Ember Imports
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

// External Imports
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

// Internal Imports
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class IndexRoute extends Route {
  queryParams = {
    authorIds: {
      refreshModel: true,
    },
    autoFilter: {
      refreshModel: true,
    },
    endTime: {
      refreshModel: true,
    },
    offset: {
      refreshModel: true,
    },
    searchQuery: {
      refreshModel: true,
    },
    startTime: {
      refreshModel: true,
    },
  };

  // Services
  @service
  dates;

  @service
  session;

  @service
  store;

  model(params) {
    let offset = 0;
    if (!isEmpty(params.offset)) {
      let temp = Number(params.offset);
      if (!Number.isNaN(temp) && temp > 0) {
        offset = temp;
      }
    }
    let authorIds = '';
    if (!isEmpty(params.authorIds)) {
      authorIds = JSON.stringify(params.authorIds);
    }
    let searchQuery = '';
    if (!isEmpty(params.searchQuery)) {
      searchQuery = params.searchQuery;
    }
    let startTime = 0;
    if (!isEmpty(params.startTime)) {
      startTime = moment(params.startTime).startOf('day').unix();
    }
    let endTime = 0;
    if (!isEmpty(params.endTime)) {
      endTime = moment(params.endTime).endOf('day').unix();
    }
    if (!isEmpty(params.autoFilter)) {
      switch (params.autoFilter) {
        case 'day':
          startTime = moment().startOf('day').unix();
          endTime = moment().endOf('day').unix();
          break;
        case 'week':
          startTime = moment().startOf('week').unix();
          endTime = moment().endOf('week').unix();
          break;
        case '7-days':
          startTime = moment().subtract(7, 'days').startOf('day').unix();
          endTime = moment().endOf('day').unix();
          break;
        default:
          this.toaster.error('Invalid Auto Filtering Option');
          break;
      }
    }

    let globalNotices;
    if (
      authorIds.length === 0 &&
      searchQuery === '' &&
      startTime === 0 &&
      endTime === 0
    ) {
      globalNotices = this.store.query('posts/globalnotice', {
        perPage: 1,
        schoolId: this.session.activeSchool,
      });
    }

    return hash({
      dailyNotices: this.store.query('posts/staffnotice', {
        perPage: 20,
        authorIds,
        endTime,
        offset,
        searchQuery,
        startTime,
        include: 'reactions,comments',
      }),
      authors: this.store.query('person', {
        type: PersonType.STAFF,
      }),
      groups: this.store.query('group', {
        year: this.dates.currentAcademicYear,
      }),
      globalNotices,
      update: () => this.refresh(),
    });
  }
}
